/* eslint-disable */
import React from 'react';
import { useSelector } from 'react-redux';

export function TextInput({
  value,
  name,
  label,
  required,
  className,
  handleChange,
  valid,
  type = 'text',
}) {
  const { submittedFlag } = useSelector(store => store.enrollment);
  let invalidClass = '';
  if (valid === false) invalidClass = 'is-invalid';
  if (valid === true) invalidClass = 'is-valid';

  return (
    <div className="col-md-6">
      <label htmlFor={name} className="form-label">
        {label}
        {required && (
          <span className="text-danger ms-1">*</span>
        )}
      </label>
      <input
        type={type}
        className={`form-control ${className} ${invalidClass}`}
        id={name}
        value={value}
        onChange={(e) => handleChange(e)}
        disabled={submittedFlag}
      />
    </div>
  );
}

